/**
 * Enum encapsulating various type a user can be-member, guest, unknown
 */ export var UserType = /*#__PURE__*/ function(UserType) {
    UserType["Member"] = "Member";
    UserType["Guest"] = "Guest";
    return UserType;
}({});
